import React, { createContext, useState, useContext } from 'react';
import ErrorModal from '../components/ErrorModal';


const ErrorContext = createContext();


export const useError = () => {
  return useContext(ErrorContext);
};


export const ErrorProvider = ({ children }) => {
  const [errorData, setErrorData] = useState({ error: null, description: '' });
  const [open, setOpen] = useState(false);

  const handleError = ({ error, description }) => {
    setErrorData({ error, description });
    setOpen(true);
  };


  const handleClose = () => {
    setOpen(false);
    setErrorData({ error: null, description: '' });
  };

  return (
    <ErrorContext.Provider value={{ handleError }}>
      {children}
      <ErrorModal
        open={open}
        handleClose={handleClose}
        error={errorData.error}
        description={errorData.description}
      />
    </ErrorContext.Provider>
  );
};
